export default __webpack_public_path__ + "static/media/LYRCS.329b23b1.mp4";